import React, { useCallback } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { styled } from "@mui/material/styles";

import { FieldError } from "../../../components";
import { MAX_PHONE_DIGITS } from "../../../const";

export const FieldContainer = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
}));

export const PersonalInfoBlock = ({
	onKeyDown,
	userObj,
	handleUserObjChange,
}) => {
	const { first_name, last_name, phone } = userObj;

	const handleFirstNameChange = useCallback(
		(e) => {
			handleUserObjChange(e.currentTarget.value, "first_name");
		},
		[handleUserObjChange]
	);
	const handleLastNameChange = useCallback(
		(e) => {
			handleUserObjChange(e.currentTarget.value, "last_name");
		},
		[handleUserObjChange]
	);

	const handlePhoneNumberChange = useCallback(
		(newValue, info) => {
			if (
				!info.numberValue?.length ||
				info.numberValue.length <= MAX_PHONE_DIGITS
			) {
				handleUserObjChange(info.numberValue, "phone");
			}
		},
		[handleUserObjChange]
	);

	return (
		<>
			<FieldContainer>
				<Typography>First name *</Typography>
				<TextField
					fullWidth
					autoComplete="given-name"
					variant="outlined"
					size="small"
					error={first_name.showError}
					value={first_name.value}
					onKeyDown={onKeyDown}
					onChange={handleFirstNameChange}
					inputProps={{ "aria-label": "given-name" }}
				/>
				{first_name.showError && <FieldError />}
			</FieldContainer>

			<FieldContainer>
				<Typography>Last name *</Typography>
				<TextField
					fullWidth
					autoComplete="family-name"
					variant="outlined"
					size="small"
					error={last_name.showError}
					value={last_name.value}
					onKeyDown={onKeyDown}
					onChange={handleLastNameChange}
					inputProps={{ "aria-label": "family-name" }}
				/>
				{last_name.showError && <FieldError />}
			</FieldContainer>

			<FieldContainer>
				<Typography>Telephone number</Typography>
				<MuiTelInput
					fullWidth
					autoComplete="tel"
					size="small"
					defaultCountry="US"
					error={phone.showError}
					value={phone.value}
					onKeyDown={onKeyDown}
					onChange={handlePhoneNumberChange}
					inputProps={{ "aria-label": "phone-number" }}
				/>
				{phone.showError && <FieldError field="phone" />}
			</FieldContainer>
		</>
	);
};
